import React, { useState } from 'react';
import { formValidation } from '../Utils/index';
import CommonModal from './CommonModal';
import CommonTextField from './CommonTextField';
import CommonPasswordField from './CommonPasswordField';

const UserCreation = ({
  userType, setModal, createUser, title,
}) => {
  const [state, setState] = useState({
    username: '', email: '', mobile: '', password: '123',
  });
  const [validation, formValidate] = useState(null)

  const handleChange = (val, field) => {
    setState((prevState) => ({
      ...prevState,
      [field]: val,
    }));
  };

  const submitForm = async () => {
    const validateState = { ...state }
    const valid = await formValidation(validateState, userType)
    if (userType === 'monitor') {
      if (!validateState.email) delete validateState.email;
      if (!validateState.mobile) delete validateState.mobile;
    }
    if (valid === undefined) {
      formValidate(null)
      createUser(validateState)
    } else {
      formValidate(valid)
    }
  }
  const {
    username, password,
  } = state
  return (
    <CommonModal
      title={title}
      width="xl"
      open
      onYes={submitForm}
      onClose={() => setModal(false)}
      successButtonText="Create User"
      cancelButtonText="Cancel"
      disableEscapeKeyDown
      disableBackdropClick
      saveBtnDisable={
        !username.trim() || !password.trim()
      }
    >
      <div className="row">
        <div className="col-6">
          <CommonTextField error={validation && validation.username} handleChange={handleChange} name="username" label="Username" placeholder="username" helperText={validation && validation.username && validation.username.length > 0 ? validation.username[0] : ''} required />
        </div>
        <div className="col-6">
          <CommonTextField error={validation && validation.email} handleChange={handleChange} name="email" label="Email" placeholder="Email" type="email" helperText={validation && validation.email && validation.email.length > 0 ? validation.email[0] : ''} required={userType !== 'monitor'} />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <CommonTextField error={validation && validation.mobile} handleChange={handleChange} name="mobile" label="Mobile No." placeholder="Mobile No." type="tel" helperText={validation && validation.mobile && validation.mobile.length > 0 ? validation.mobile[0] : ''} required={userType !== 'monitor'} />
        </div>
        <div className="col-6">
          <CommonPasswordField
            validation={validation && validation.password ? validation.password : null}
            handleChange={handleChange}
          />
        </div>
      </div>
    </CommonModal>
  );
}

export default UserCreation;
